import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Inbox(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Inbox", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M40 9.99999V22h-7c-.8 0-1.4.4-1.8 1l-2.4 5h-9.6l-2.4-5c-.4-.6-1-1-1.8-1H8V9.99999c0-.4.2-.8.4-1.2L24 20 39.8 8.99999c.2.2.2.6.2 1Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M44 24v14c0 1-1 2-2 2H6c-1 0-2-1-2-2V24c0-1 1-2 2-2h9c.8 0 1.4.4 1.8 1l2.4 5h9.6l2.4-5c.4-.6 1-1 1.8-1h9c1 0 2 1 2 2Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M39.8 9 24 20 8.39999 8.8c.4-.4 1-.8 1.6-.8H38c.8 0 1.4.4 1.8 1Z",
        fill: theme.vars.palette.secondary.main
      }
    )
  ] });
}
Inbox.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Inbox"
};
validateTidalLicense();
export {
  Inbox
};
//# sourceMappingURL=Inbox.js.map
